import { createFileRoute, redirect } from "@tanstack/react-router";
import { ROUTES } from "#/lib/routes";

export const Route = createFileRoute("/account/")({
  beforeLoad: () => {
    throw redirect({ to: ROUTES.accountProfile });
  },
});
